import {Container} from "../Core/Container";
import {IRectangle} from "../Core/Geom";
import {array} from "../Core/Reflection";
import {Sprite} from "../Core/Sprite";

export class TiledSprite extends Container {

    public readonly tiles = array(() => this.addChild(new Sprite()));

    public onLayout() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        for (const tile of this.tiles) {
            for (const p of ["x", "y", "width", "height"] as (keyof IRectangle)[]) {
                tile[p] = Math.round(tile[p]);
            }
        }
    }
}